export default __webpack_public_path__ + "static/media/D007.b18af72a.jpg";